
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("fmdzI"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("fmdzI", function(module, exports) {

let $b2e370d061cedc66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2e370d061cedc66$var$load("h3ABO"),
    $b2e370d061cedc66$var$load("fSobj"),
    $b2e370d061cedc66$var$load("74u2y"),
    $b2e370d061cedc66$var$load("2YffH"),
    $b2e370d061cedc66$var$load("6mHrv"),
    $b2e370d061cedc66$var$load("awWN9"),
    $b2e370d061cedc66$var$load("9CYct"),
    $b2e370d061cedc66$var$load("bLsON"),
    $b2e370d061cedc66$var$load("cPXmn"),
    $b2e370d061cedc66$var$load("hZtKG"),
    $b2e370d061cedc66$var$load("iNmaF"),
    $b2e370d061cedc66$var$load("lVO3w"),
    $b2e370d061cedc66$var$load("hyzoX"),
    $b2e370d061cedc66$var$load("h9Ed7"),
    $b2e370d061cedc66$var$load("eBRUf"),
    $b2e370d061cedc66$var$load("b2zxR"),
    $b2e370d061cedc66$var$load("tKhaz"),
    $b2e370d061cedc66$var$load("GYf7c"),
    $b2e370d061cedc66$var$load("ceKWn"),
    $b2e370d061cedc66$var$load("cD6Zr"),
    $b2e370d061cedc66$var$load("dtASV"),
    $b2e370d061cedc66$var$load("kWohI"),
    $b2e370d061cedc66$var$load("9wzNh"),
    $b2e370d061cedc66$var$load("8YSo7"),
    $b2e370d061cedc66$var$load("3Zfzp"),
    $b2e370d061cedc66$var$load("Wowvf"),
    $b2e370d061cedc66$var$load("9ldRJ"),
    $b2e370d061cedc66$var$load("kiGNy"),
    $b2e370d061cedc66$var$load("8MibG"),
    $b2e370d061cedc66$var$load("gY58C"),
    $b2e370d061cedc66$var$load("1MlIV"),
    $b2e370d061cedc66$var$load("g9CVe"),
    $b2e370d061cedc66$var$load("7oiUM"),
    $b2e370d061cedc66$var$load("8t3po"),
    $b2e370d061cedc66$var$load("855o0"),
    $b2e370d061cedc66$var$load("8MfZE"),
    $b2e370d061cedc66$var$load("hv4mn"),
    $b2e370d061cedc66$var$load("dYtBN"),
    $b2e370d061cedc66$var$load("6wr18"),
    $b2e370d061cedc66$var$load("kjZZD"),
    $b2e370d061cedc66$var$load("2zxmz"),
    $b2e370d061cedc66$var$load("7269o"),
    $b2e370d061cedc66$var$load("jjLHK"),
    $b2e370d061cedc66$var$load("cxoS1"),
    $b2e370d061cedc66$var$load("37ldp"),
    $b2e370d061cedc66$var$load("ffEVr"),
    $b2e370d061cedc66$var$load("dRpV3"),
    $b2e370d061cedc66$var$load("dTsOE"),
    $b2e370d061cedc66$var$load("hhss7"),
    $b2e370d061cedc66$var$load("jwTn5"),
    $b2e370d061cedc66$var$load("aYdgM"),
    $b2e370d061cedc66$var$load("6u1hm"),
    $b2e370d061cedc66$var$load("klApM"),
    $b2e370d061cedc66$var$load("eQgf0"),
    $b2e370d061cedc66$var$load("8fMw3"),
    $b2e370d061cedc66$var$load("hogcU"),
    $b2e370d061cedc66$var$load("74vOE"),
    $b2e370d061cedc66$var$load("7EorR"),
    $b2e370d061cedc66$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.687e5667.js.map
